import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ModalModule } from 'ngx-bootstrap/modal';

import { ComponentContainerModalComponent } from './component-container-modal/component-container-modal.component';
import { ErrorModalComponent } from './error-modal/error-modal.component';
import { SharedCommonModule } from '@shared/shared-common.module';
import { ConfirmModalComponent } from './confirm-modal/confirm-modal.component';

@NgModule({
  imports: [
    SharedCommonModule,
    FormsModule,
    ReactiveFormsModule,
    ModalModule.forRoot()
  ],
  declarations: [
    ComponentContainerModalComponent,
    ConfirmModalComponent,
    ErrorModalComponent
  ],
  entryComponents: [
    ComponentContainerModalComponent,
    ConfirmModalComponent,
    ErrorModalComponent
  ],
})
export class ModalsModule { }
